export default __webpack_public_path__ + "static/media/rewards-legs.96ce0343.jpg";